"use client";
import { jsx as r, jsxs as d } from "react/jsx-runtime";
import * as t from "@radix-ui/react-popover";
import { forwardRef as p } from "react";
import { appendToChildren as c } from "../../../utils/appendToChildren.mjs";
import { DEFAULT_ICON_CLASS_NAME as v } from "../../../utils/iconDefaults.mjs";
import { Close as m } from "../Icon/icons.gen.mjs";
import { VisuallyHidden as P } from "../VisuallyHidden/VisuallyHidden.mjs";
const R = (o) => /* @__PURE__ */ r(t.Root, { "data-slot": "popover", ...o }), f = p((o, e) => /* @__PURE__ */ r(t.Trigger, { "data-slot": "popover-trigger", ...o, ref: e }));
f.displayName = "PopoverTrigger";
const C = p((o, e) => /* @__PURE__ */ r(t.Anchor, { "data-slot": "popover-anchor", ...o, ref: e }));
C.displayName = "PopoverAnchor";
const h = (o) => /* @__PURE__ */ r(t.Portal, { "data-slot": "popover-portal", ...o }), s = p((o, e) => /* @__PURE__ */ r(t.Close, { "data-slot": "popover-close", ...o, ref: e }));
s.displayName = "PopoverClose";
const A = p((o, e) => /* @__PURE__ */ r(t.Arrow, { "data-slot": "popover-arrow", ...o, ref: e }));
A.displayName = "PopoverArrow";
const g = p(
  ({ children: o, showCloseButton: e = !1, closeLabel: l = "Close", asChild: a, ...i }, n) => /* @__PURE__ */ r(h, { children: /* @__PURE__ */ r(t.Content, { "data-slot": "popover-content", asChild: a, ...i, ref: n, children: c(
    o,
    e && /* @__PURE__ */ d(s, { children: [
      /* @__PURE__ */ r(
        m,
        {
          "data-slot": "popover-close-icon",
          "aria-hidden": "true",
          className: v
        }
      ),
      /* @__PURE__ */ r(P, { children: l })
    ] }),
    a
  ) }) })
);
g.displayName = "PopoverContent";
export {
  C as PopoverAnchor,
  A as PopoverArrow,
  s as PopoverClose,
  g as PopoverContent,
  h as PopoverPortal,
  R as PopoverRoot,
  f as PopoverTrigger
};
